module.exports = __webpack_public_path__ + "static/media/menu_items.2cd190c0.svg";